export const ROUTE = {
  VERIFICATION: {
    MAIN: 'verification',
    BEFORE_YOU_BEGIN: '',
    VERIFYING: 'verifying',
    SENDING_OTP: 'sending-otp',
    GETTING_STARTED: 'getting-started',
  },
  SINGPASS: {
    MAIN: '',
    CALLBACK: 'callback',
  },
  PLAYGROUND: {
    MAIN: 'playground',
    EXPAND: 'expand',
    FORM: 'form',
    LOADING: 'loading',
    PDFMAKER: 'pdfmaker',
    PDF_VIEWER: 'pdf-viewer',
    STEPPER: 'stepper',
    RECAPTCHA: 'recaptcha',
    DIALOG: 'dialog',
  },
  APPLICATION: {
    MAIN: 'application',
    PROPRIETOR: 'proprietor',
    PARTNERSHIP: 'partnership',
    SECRETARY: 'secretary',
    THANK_YOU: 'thank-you',
  },
  BROKER: {
    MAIN: 'broker',
    APPLICANT_DETAIL: 'applicant-detail',
    VERIFY: 'verify',
    THANK_YOU: 'thank-you',
    REGISTRATION_THANK_YOU: 'registration-thank-you',
  },
  SIGNING: {
    MAIN: 'document',
    PREVIEW: 'preview',
    SIGNING: 'signing',
  },
  CBS_CONSENT: {
    MAIN: 'cbs-consent',
    BEFORE_BEGIN: 'before-begin',
    SEND_OTP: 'send-otp',
    CONFIRMATION: 'confirmation',
    SUCCESS: 'success',
    ERROR: {
      MAIN: 'error',
      EXPIRED: 'expired',
    },
    QUERY_PARAM: { CODE: 'code', NRIC: 'nric' },
  },
  INDIVIDUAL: {
    MAIN: 'myinfo-consent',
    BEFORE_BEGIN: 'before-begin',
    SEND_OTP: 'send-otp',
    CONFIRMATION: 'confirmation',
    GETTING_STARTED: 'getting-started',
    CALLBACK: 'callback',
    SUCCESS: 'success',
    ERROR: {
      MAIN: 'error',
      EXPIRED: 'expired',
      UNABLE_PROCEED: 'unable-proceed',
    },
    QUERY_PARAM: {
      CODE: 'code',
      NRIC: 'nric',
      MYINFO_CODE: 'code',
      MYINFO_STATE: 'state',
    },
  },
  ERROR: {
    MAIN: 'error',
    400: '400',
    403: '403',
    404: '404',
    500: '500',
  },
} as const;
